/** ****************************************************************************
		███╗   ██╗███████╗██████╗  █████╗  ██████╗
		████╗  ██║██╔════╝██╔══██╗██╔══██╗██╔═══██╗
		██╔██╗ ██║█████╗  ██║  ██║███████║██║   ██║
		██║╚██╗██║██╔══╝  ██║  ██║██╔══██║██║   ██║
		██║ ╚████║███████╗██████╔╝██║  ██║╚██████╔╝
		╚═╝  ╚═══╝╚══════╝╚═════╝ ╚═╝  ╚═╝ ╚═════╝

@module Link
@description Composant de navigation

@author Victor Audetat <audetat.v@gmail.com>

@copyright © 2020  NEDAO Association (info@nedao.ch)
@see {@link https://association.nedao.ch}

@license
	This program is free software: you can redistribute it and/or modify
	it under the terms of the GNU Affero General Public License as published
	by the Free Software Foundation, either version 3 of the License, or
	(at your option) any later version.

	This program is distributed in the hope that it will be useful,
	but WITHOUT ANY WARRANTY; without even the implied warranty of
	MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
	GNU Affero General Public License for more details.

	You should have received a copy of the GNU Affero General Public License
	along with this program.  If not, see <https://www.gnu.org/licenses/>.
*******************************************************************************/

import React, {useEffect, useState} from "react";
import { Link } from "react-router-dom";
import logo from "url:./../../media/logo.svg";
import "./nav.scss";

const Nav = (props) => {

	const [position, setPosition] = useState({
		lastPosition: 0,
		actualPosition: 0,
		scrollUp: true,
	});

	const scrollLimit = 50;

	useEffect(() => {
		window.addEventListener("scroll", scrollEffect);
		return () => {
			window.removeEventListener("scroll", scrollEffect);
		};
	}, [position]);

	const scrollEffect = () => {
		const yPosition = window.pageYOffset;
		if(yPosition > position.lastPosition && yPosition > 100){
			setPosition({
				lastPosition: yPosition,
				actualPosition: yPosition,
				scrollUp: false
			});

		} else if(yPosition <= position.lastPosition) {
			setPosition({
				lastPosition: yPosition,
				actualPosition: yPosition,
				scrollUp: true
			});
		}
	};

	const style = {
		img: {
			position: position.actualPosition > scrollLimit ? "fixed" : "absolute",
			top: position.actualPosition > scrollLimit ? "55px" : "160px",
			width: position.actualPosition > scrollLimit ? "75px" : "200px",
			transition: "all 500ms" 
		},
		fixed: {
			position: "fixed",
			top: "55px",
			width: "75px",
			transition: "all 500ms" 
		},
		navigation: {
			backgroundColor: "#fff",
			position: "fixed",
			dispay: "block",
			width: "100%",
			left: 0,
			top: position.scrollUp ? "0" : "-200px",
			transition: "all 200ms ease-in-out",
			zIndex: 3000,
		},
		link: {
			position: "relative",
			top: position.scrollUp ? "0" : "-200px",
			transition: "all 200ms ease-in-out",
			zIndex: 2999 ,
		}
	};

	return (
		<>			
			<span className="navigation-background" style={style.navigation} />
			<nav>
				<Link to="/"><img id="logo" src={logo} style={props.bigLogo ? style.img : style.fixed}/></Link>
				<Link style={style.link} className="nav__about-link" to="/about"> A propos</Link>
			</nav>
		</>
	);
};

export default Nav;